export default {
  data() {
    return {
      baseTitle: 'DealPrudence'
    }
  },
  methods: {
    updatePageTitle(title) {
      if (title) {
        document.title = `${title} - ${this.baseTitle}`
      } else {
        document.title = this.baseTitle
      }
    },
    getPageTitleFromRoute() {
      const currentPath = this.$f7route?.path || window.location.pathname
      
      // Mapping des routes vers les clés de traduction
      const routeTitleMap = {
        '/homepage/': 'Webheader.homepage',
        '/tracking/': 'Webheader.tracking',
        '/user-company/': 'Webheader.userCompany',
        '/company/': 'Webheader.company',
        '/accounts/': 'Webheader.accounts',
        '/history/': 'Webheader.history',
        '/profile-company/': 'Webheader.profileCompany',
        '/alerts/': 'Webheader.alerts',
        '/alerts-history/': 'Webheader.alertsHistory',
        '/biconus/': 'Webheader.biconus',
        '/entity-account/': 'Webheader.entityAccount',
        '/global-config/': 'Webheader.globalConfig',
        '/monitoring/': 'Webheader.monitoring',
        '/orphan/': 'Webheader.orphan',
        '/routing/': 'Webheader.routing',
        '/security/': 'Webheader.security',
        '/tracking-bulk/': 'Webheader.trackingBulk',
        '/vop-provider/': 'Webheader.vopProvider',
        '/annuaire/': 'Webheader.annuaire',
        '/email/': 'Webheader.email',
        '/rights/': 'Webheader.rights',
        '/account-tb/': 'Webheader.accountTB',
        '/test-case-report/': 'Webheader.testCaseReport',
        '/toolbox-requester/': 'Webheader.toolboxRequester',
        '/toolbox-responder/': 'Webheader.toolboxResponder'
      }
      
      // Chercher la clé de traduction correspondante
      for (const [route, titleKey] of Object.entries(routeTitleMap)) {
        if (currentPath.startsWith(route)) {
          return this.$t(titleKey)
        }
      }
      
      return null
    }
  },
  mounted() {
    // Mettre à jour le titre lors du montage du composant
    const routeTitle = this.getPageTitleFromRoute()
    if (routeTitle) {
      this.updatePageTitle(routeTitle)
    }
  },
  beforeDestroy() {
    // Réinitialiser le titre lors de la destruction du composant
    document.title = this.baseTitle
  }
}